import { Plus, Trash2 } from "lucide-react";
import { InputText } from "primereact/inputtext";
import React from "react";
import { dateValue, SectionTitle } from "../EmployeeForm";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { toIST } from "../../../utils/calculateMargin";
import { Button } from "../../../ui/buttons";

const assetStatusOptions = ["Issued", "Returned", "Damaged"].map((x) => ({
  label: x,
  value: x,
}));

function CompanyAssets({
  assets,
  setAssets,
  updateArray,
  removeArrayItem,
  emptyAsset,
}) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Company Assets</SectionTitle>

      {assets.map((item, index) => (
        <div
          key={index}
          className="grid grid-cols-1 lg:grid-cols-6 gap-3 border p-3 rounded-md"
        >
          <InputText
            value={item.modelNumber}
            onChange={(e) =>
              updateArray(setAssets, index, "modelNumber", e.target.value)
            }
            placeholder="Model Number"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <InputText
            value={item.assetName}
            onChange={(e) =>
              updateArray(setAssets, index, "assetName", e.target.value)
            }
            placeholder="Asset Name *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <InputText
            value={item.serialNumber}
            onChange={(e) =>
              updateArray(setAssets, index, "serialNumber", e.target.value)
            }
            placeholder="Serial Number"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <Dropdown
            value={item.status}
            options={assetStatusOptions}
            onChange={(e) => updateArray(setAssets, index, "status", e.value)}
            placeholder="Status *"
            className="w-full px-1 text-sm border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <Calendar
            value={dateValue(item.issuedOn)}
            onChange={(e) =>
              updateArray(setAssets, index, "issuedOn", toIST(e.value))
            }
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="Issued On *"
            className="w-full bg-input border border-gray-300 rounded-md"
            inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
          />
          <div className="flex gap-2">
            <Calendar
              value={dateValue(item.returnedOn)}
              onChange={(e) =>
                updateArray(setAssets, index, "returnedOn", toIST(e.value))
              }
              showIcon
              dateFormat="dd/mm/yy"
              placeholder="Returned On"
              className="w-full bg-input border border-gray-300 rounded-md"
              inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
            />

            <Button
              type="button"
              variant="ghost"
              onClick={() => removeArrayItem(setAssets, index)}
            >
              <Trash2 className="h-4 w-4 text-red-500" />
            </Button>
          </div>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setAssets((prev) => [...prev, { ...emptyAsset }])}
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add Asset
      </Button>
    </section>
  );
}

export default CompanyAssets;
